import { render, staticRenderFns } from "./MostrarInformacion.vue?vue&type=template&id=4cebeeb2&scoped=true"
import script from "./MostrarInformacion.vue?vue&type=script&lang=js"
export * from "./MostrarInformacion.vue?vue&type=script&lang=js"
import style0 from "./MostrarInformacion.vue?vue&type=style&index=0&id=4cebeeb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cebeeb2",
  null
  
)

export default component.exports